import { authClient } from "@features/auth/authClient";
import { AuthRoute } from "@features/auth/AuthRoute";
import { AppleIcon, GoogleIcon } from "@features/auth/SocialIcons";
import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { Button } from "@shadcn/ui/button";
import { Separator } from "@shadcn/ui/separator";
import { toast } from "sonner";

export const SocialSignInAndUp = () => {
	const { callbackUrl } = AuthRoute.useLoaderData();
	const LL = useI18nContext().LL.auth;

	const onClick = async (provider: "google" | "apple") => {
		const res = await authClient.signIn.social({
			provider,
			callbackURL: callbackUrl,
		});
		if (res.error) {
			return toast.error(res.error.message);
		}
		if (!res.data.url) {
			return toast.error("Something went wrong. Please try again.");
		}
		if (res.data.redirect) {
			window.location.href = res.data.url;
		}
	};

	return (
		<>
			<div className="space-y-2">
				<Button variant="outline" className="w-full" type="button" onClick={() => onClick("google")}>
					<GoogleIcon />
					<span>
						<T>{LL.SIGN_IN_WITH_PROVIDER({ provider: "Google" })}</T>
					</span>
				</Button>
				{/* <Button variant="outline" className="text-foreground w-full" type="button" onClick={() => onClick("apple")}>
					<AppleIcon />
					<span>
						<T>{LL.SIGN_IN_WITH_PROVIDER({ provider: "Apple" })}</T>
					</span>
				</Button> */}
			</div>
			<div className="relative w-full">
				<div className="bg-background text-muted-foreground absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform px-2 text-xs uppercase">
					<T>{LL.SOCIAL_SIGN_IN_UP_ORLINE()}</T>
				</div>
				<Separator />
			</div>
		</>
	);
};
